import {
  external_evaluator_evaluation_summary_data_path,
  external_evaluator_summary_path
} from '~/routes'

export const ExternalEvaluator = {
	index: function() {
    jQuery('.video-box').on('click', function() {
      var dialog = jQuery('#modal-dialog');

      var dialogContent = "<div class='embed-SThnTHSnjh'></div><script type='text/javascript' src='https://video.adalia.fi/embed/s/SThnTHSnjh?width=responsive'></script>";
      dialog.find('.modal-dialog').addClass('modal-lg')
      dialog.find('.modal-body').html(dialogContent);
      dialog.find('.modal-footer').remove();
      dialog.modal();

      dialog.find('.modal-header .close').on('click', function(){
        jQuery(this).closest('#modal-dialog').find('.modal-body').html("");
      })

      return false;
    });
  },
  
  list: function() {
    jQuery('table#applications-table').DataTable({
      searching: true,
      pageLength: 25,
      lengthChange: false,
	  language: {
        searchPlaceholder: I18n.t('search')
      },
      columnDefs: [
        {
          sortable: true,
          searchable: true,
      		targets: [0]
        },
        {
          sortable: true,
          searchable: true,
      		targets: [1]
        },
        {
          sortable: true,
          searchable: true,
      		targets: [2]
        },
        {
          sortable: true,
          searchable: true,
      		targets: [3]
        },
      ],
      drawCallback: function() {
        DataTablesHelper.addColumnFilters(this);
      },
      footerCallback: function () {
        DataTablesHelper.togglePagination(this);
      }
    });
  },

	support: function() {
		var barOffset = $('.main.clearfix').outerHeight(true) - $('.main.clearfix').outerHeight() + $('.navbar-fixed-top').outerHeight();
		if ($('#answer-section').length > 0) {
			window.scrollTo(0, $('#answer-section').offset().top - barOffset);
		}
		
		var offset = $('#submit-question').offset().top - barOffset;
		$('#submit-question').offset({top: offset});
		var offset = $('#faq').offset().top - barOffset;
		$('#faq').offset({top: offset});

		jQuery('.faq .faq-question').on('click', function (e) {
			jQuery(this).toggleClass('active');
			e.preventDefault();
			jQuery(this).closest('.faq-content').find('.faq-answer').toggleClass('hidden');

			return false;
		})
	},

	evaluation_summary: function() {
		var eval_cols = jQuery('table.concept-notes').data('evaluator-columns');
		var options = {
			serverSide: true,
	        ajax: {
	          url: external_evaluator_evaluation_summary_data_path({
	            format:'json',
	            call_id: $('.concept-notes').data('call-id'),
	            phase_id: $('.concept-notes').data('selected-phase-id')}),
	          type: 'post',
	        },
	        // deferRender: true,
	        sorting: [[0, 'asc']],
	        // info: true,
	        lengthChange: true,
	        lengthMenu: [ [20, 50, -1], [20, 50, I18n.t('all')] ],
			language: {
				searchPlaceholder: I18n.t('search')
			  },
	        pageLength: 20,
	        autoWidth: false,
	        searching: true,
	        searchDelay: 1200,
	        stateSave: true,
	        processing: true,
	        columnDefs: [
	        	{	// Project id
	        		render: function(data) {
		        		var url = external_evaluator_summary_path({
				            format: null,
				            note_id: data.id,
				            phase_id: data.phase
				        });
	           			var projectLink = jQuery('<a>').attr('href', url).text(data.name);
	                	return jQuery('<div>').append(projectLink).html();
                	},
	        		width: '120px',
	        		targets: [0]
	        	},
	        	{	// Title
	        		render: function(data) {
	        			var container = jQuery('<div>').addClass('evaluation-title-container').attr('title', data);
	        			container.html(data);
                		return jQuery('<div>').append(container).html();
	        		},
	        		className: 'name-cell',
	        		sortable: true,
	        		targets: [1]
	        	},
		        {	// Evaluators
					render: function(data) {
						if (data.score) {
							var container = jQuery('<div>').addClass('evaluator-assingment-container selected');
							var selected = jQuery('<span>').addClass('evaluator-assign-icon selected ' + (data.recommended == 'yes' ? 'green' : (data.recommended == 'no' ? 'red' : '')));
							selected.text(data.score);
							container.append(selected);
							return jQuery('<div>').append().append(container).html();
						}
						else
							return " ";
		            },
		            width: '40px',
		            sortable: true,
		            className: 'evaluator-cell',
		            targets: eval_cols
		        },
		        {	// Average
		        	render: function(data) {
		        		var container = jQuery('<div>').text(parseFloat(data).toFixed(0));
		        		return jQuery('<div>').append(container).html();
		        	},
		        	className: 'average-cell',
		        	width: '50px',
		        	sortable: true,
		        	targets: eval_cols[eval_cols.length-1]+1
		        },
		        {	// Results
		        	render: function(data) {
		        		data = parseInt(data);
		        		var container = jQuery('<div>').addClass('result-content');
		        		if (data > 1)
		        			container.append(jQuery('<i>').addClass('fa fa-thumbs-up'));
		        		else if (data < 0)
		        			container.append(jQuery('<i>').addClass('fa fa-thumbs-down'));
		        		return jQuery('<div>').append(container).html();
		        	},
		        	width: '75px',
		        	sortable: true,
		        	targets: eval_cols[eval_cols.length-1]+2
		        }
	        ],
            footerCallback: function () {
                DataTablesHelper.togglePagination(this);
            }
	    }
	    jQuery('.table.concept-notes').DataTable(options);
	},

  evaluate: function() {
    var form = jQuery('#evaluation-form');
    var inputs = form.find('.form-component').find('input, select, textarea').filter('.prescoring *');

    // Disable prescoring component fields
    inputs.prop('disabled', true).attr('readonly', 'readonly');
    // Disable prescoring attachment fields
    var dropzones = form.find('.form-component.prescoring .dropzone');
    dropzones.each(function() { Dropzone.forElement(this).destroy(); });
    dropzones.find('.btn, .dz-message').remove();
    dropzones.addClass('disabled', true);
  }
};